import mutations from './mutations'
import actions from './actions'
import getters from './getters'

import workflowStepRequirement from '../assets/_workflowStepRequirement'


export default {
  namespaced: true,
  state: {
    selections: [],
    giList: {

    },
    newGI: {
      workflowStepRequirement: workflowStepRequirement.requirements,
      workflowCurrentStep: 0,
      policyTypeList: [],
      policyFields: [],
      policyID: -1,
      approveAgent: {
        chinese: '',
        english: ''
      },
      originalAgent: {
        chinese: '',
        english: ''
      },
      currentAgent: {
        chinese: '',
        english: ''
      },
      insuredCustomer: {
        chinese: '',
        english: ''
      },
      ownerCustomer: {
        chinese: '',
        english: ''
      },
      productName: {
        chinese: '',
        english: ''
      },
      paymentMethodID: -1,
      giTypeID: -1,
      isRejected: false,
      isCompleted: false,
      giGeneralInfo: {

        productID: 1,
        policyNumber: '',
        policyReference: '',
        policyStatus: '',
        applicationDate: '',
        applicationReceiveDate: '',
        policyCurrency: 'HKD',
        policyType: '',
        customerActuallyPaid: 0,
        modalPremium: 0,
        policyAgent: [{
          agentID: -1,
          agentSplitRate: '',
          isActive: "Y",
          isServiceAgent: "Y",
          effectiveDate: '',
          expiryDate: ''
        }],
        // originalAgent: -1,
        // currentAgent: -1,
        ownerCustomer: -1,
        insuredCustomer: -1,
        policyFee: 0,
        agentCommissionRate: 0,
        newBusinessOrRenewal: 'N',
        levyOrMib: 0,
        specialLevy:0,
        remarks: '',
        premiumPaid: 0,
        approveAgent: -1,
        agentCommissionPaid: 0,
        insurerRebate: 0,
        // chequeToFortune: 0,
        // chequeToFortuneNumber: '',
        chequeToInsurer: 0,
        chequeToInsurerNumber: '',
        chequeIssueDate: '',
        sentOutDate: '',
        sentOutMedium: '',
        sentOutReference: '',
        // courierNumber: '',
        effectiveDate: '',
        expiryDate: '',
        issueDate: '',
        companyReceiveDate: '',
        agentReceiveDate: '',
        customerReceiveDate: '',
        policyAgentChangeReason: '',
        // version: 1,
        docs: {}
      },
      giPaymentMethod: {
        paymentMethod: "I",
        companyBank: "",
        paymentReference: "",
        paymentDate: "",
        paymentAmount: 0,
        // version: 1
      },
      giTypeInfo: {},
      giAttachments: [],
      fields: {

        orSection: { disabled: true, hide: true },
        saveBtn: { disabled: true, hide: true },
        nextBtn: { disabled: false, hide: false },
        prevBtn: { disabled: true, hide: true },
        inforceBtn: { disabled: true, hide: true },
        rejectBtn: { disabled: true, hide: true },
        policyInfomation: { disabled: false, hide: false, value: null },
        productName: { disabled: false, hide: false, value: '' },
        deleteBtn: { disabled: false, hide: true },
        policyNumber: { disabled: false, hide: false, value: '' },
        policyReference: { disabled: false, hide: false, value: '' },
        applicationDate: { disabled: false, hide: false, value: '' },
        applicationReceiveDate: { disabled: false, hide: false, value: '' },
        policyCurrency: { disabled: false, hide: false, value: '' },
        policyType: { disabled: false, hide: false, value: '' },
        modalPremium: { disabled: false, hide: false, value: 0 },
        premiumPaid: { disabled: false, hide: false, value: 0 },
        premiumType: { disabled: false, hide: false, value: '' },
        actuallyPaid: { disabled: false, hide: false, value: 0 },
        paymentMethod: { disabled: false, hide: false, value: '' },
        companyBank: { disabled: false, hide: false, value: null },
        paymentReference: { disabled: false, hide: false, value: '' },
        paymentAmount: { disabled: false, hide: false, value: 0 },
        paymentDate: { disabled: false, hide: false, value: '' },
        originalAgent: { disabled: false, hide: false, value: '' },
        policyAgent: { disabled: false, hide: false },
        currentAgent: { disabled: false, hide: false, value: '' },
        ownerCustomer: { disabled: false, hide: false, value: '' },
        insuredCustomer: { disabled: false, hide: false, value: '' },
        policyFee: { disabled: false, hide: false, value: 0 },
        agentCommissionRate: { disabled: false, hide: false, value: 0 },
        agentCommissionPaid: { disabled: false, hide: false, value: null },
        newBusinessOrRenewal: { disabled: false, hide: false, value: null },
        levyOrMIB: { disabled: false, hide: false, value: 0 },
        specialLevy: { disabled: false, hide: false, value: 0 },
        premiumPaid: { disabled: false, hide: false, value: 0 },
        insurerRebate: { disabled: false, hide: false, value: 0 },
        chequeToInsurer: { disabled: false, hide: false, value: '' },
        chequeToInsurerNumber: { disabled: false, hide: false, value: '' },
        chequeIssueDate: { disabled: false, hide: false, value: '' },
        remarks: { disabled: false, hide: false, value: '' },
        docs: { disabled: false, hide: false, value: '' },
        sentOutDate: { disabled: false, hide: true, value: '' },
        sentOutMedium: { disabled: false, hide: true, value: null },
        sentOutReference: { disabled: false, hide: true, value: '' },
        // courierNo: { disabled: false, hide: true, value: '' },
        effectiveDate: { disabled: false, hide: true, value: '' },
        expiryDate: { disabled: false, hide: true, value: '' },
        issueDate: { disabled: false, hide: true, value: '' },
        companyReceiveDate: { disabled: false, hide: true, value: '' },
        agentReceiveDate: { disabled: false, hide: true, value: '' },
        customerReceiveDate: { disabled: false, hide: true, value: '' }
      }
    },
    trueFalseOptions: [
      { text: 'Yes', value: "Y" },
      { text: 'No', value: "N" }
    ],
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Osm/GIPolicy/store/index.js